export class AzureSubscription {
    'id';
    'subscriptionId';
    'tenantId';
    'name';
    'state';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSubscription.attributeTypeMap;
    }
    constructor() {
    }
}
